import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const ComplianceProcessAssessment = () => {
  const serviceData = {
    title: "Compliance & Process Assessment",
    heading: "Compliance & Process Assessment",
    image: subTopicImages["Compliance & Process Assessments"],
    intro:
      "Independent evaluation of regulatory and internal compliance frameworks",
    description: [
      "Compliance today extends across multiple legislations — corporate, tax, labour, sector-specific and operational. Non-compliance can expose businesses to financial penalties, prosecution risk and reputational damage.",
      "Our compliance & process assessments help organisations evaluate whether policies, filings, processes and practices are aligned with applicable regulations and internal standards.",
    ],
    services: [
      {
        title: "Regulatory Compliance Reviews",
        text: "We conduct an independent assessment of:",
        list: [
          "statutory compliance status",
          "regulatory filings",
          "documentation readiness",
        ],
        extraInfo:
          "Helping organisations identify gaps and ensure preparedness for regulatory scrutiny.",
      },
      {
        title: "Process & Policy Assessments",
        text: "We evaluate:",
        list: [
          "process discipline",
          "adherence to internal SOPs",
          "governance benchmarks",
        ],
        extraInfo:
          "To ensure internal controls and practices are consistently followed.",
      },
      {
        title: "Corrective Action Frameworks",
        text: "We support organisations through:",
        list: [
          "gap identification",
          "remediation planning",
          "implementation guidance",
        ],
        extraInfo:
          "Ensuring corrective actions are practical, compliant and sustainable.",
      },
    ],
    benefitsIntro: "Benefits of this service:",
    benefits: [
      "Early identification of compliance gaps",
      "Reduced legal & regulatory risk",
      "Improved documentation discipline",
      "Confidence during external audits & inspections",
      "Stronger corporate governance",
    ],
    research:
      "Our structured review methodology ensures clear visibility, practical solutions and disciplined implementation support.",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default ComplianceProcessAssessment;
